import FormSelect from '../FormSelect'
import { mapState } from 'vuex'

export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        multiple: false,
        searchable: true,
      }),
    },
  },
  computed: {
    ...mapState('eventsManagement', [ 'organizations' ]),
    normalizedOptions () {
      return Object.values(this.organizations).sort((a, b) => {
        if (a.name < b.name) return -1
        else return 1
      }).map(el => el.id)
    },
  },
  methods: {
    normalizedOptionLabel (option) {
      return this.organizations[option] ? this.organizations[option].name : ''
    },
  },
}
